import {Selectable} from './select/selectable';
export class Caisse extends Selectable {
  public static readonly caisses: Map<string, Caisse> = new Map<string, Caisse>();

  constructor(
    id: string,
    public name: string,
    private caption: string
  ) {
    super(id);
  }

  public getCaption(): string {
    return this.caption;
  }

  public getData(): any {
    return {id: this.id, name: this.name, caption: this.caption};
  }
}



// WEBPACK FOOTER //
// ./src/app/caisse.ts